module.exports = __webpack_public_path__ + "img/mechanic.16030b7f.png";